import { render, staticRenderFns } from "./hotelDetails.vue?vue&type=template&id=482859a1&scoped=true&"
import script from "./hotelDetails.vue?vue&type=script&lang=js&"
export * from "./hotelDetails.vue?vue&type=script&lang=js&"
import style0 from "./hotelDetails.vue?vue&type=style&index=0&id=482859a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482859a1",
  null
  
)

export default component.exports